import { defineStore } from 'pinia'
import { computed } from 'vue'

import { useFormDataStore } from '@/stores/FormDataStore'

export const usePaymentGatewaysStore = defineStore('PaymentGatewaysStore', () => {
	const formDataStore = useFormDataStore()

	const freeGatewayCode = 'voucher'
	const goPayGatewayCodes = ['gopay', 'gopay_recurrent']

	const all = computed(() => {
		return Object.values(window.init.gateways)
			.filter(gateway => gateway.visible)
			.filter(gateway => formDataStore.isVariantTrial ? gateway.is_recurrent : true)
			.sort((s1, s2) => (s1.sorting > s2.sorting) ? 1 : (s1.sorting < s2.sorting) ? -1 : 0)
	})

	const allWithoutFree = computed(() => all.value.filter(gateway => gateway.code !== freeGatewayCode))

	const first = computed(() => allWithoutFree.value[0])

	const getGatewayByCode = code => all.value.find(gateway => gateway.code === code)

	const isGoPayGateway = code => goPayGatewayCodes.includes(code)

	return {
		all,
		allWithoutFree,
		first,
		freeGatewayCode,
		isGoPayGateway,
		getGatewayByCode
	}
})